import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "rearAndMachine",
    iconColor: "white",
    text: "Embed automated RAI\nWorkflows in internal\nprocesses and systems",
    listItemCustomStyle: { width: "305px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "worldAndCheckmark",
    iconColor: "white",
    text: "To protect against the\nvulnerabilities of LLMs and\nfoundation models",
    listItemCustomStyle: { width: "400px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "schieldWithCheckmark",
    iconColor: "white",
    text: "Enterprise AI security\n solutions that detect\n different adversarial attacks",
    listItemCustomStyle: { width: "400px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "personInsideChip",
    iconColor: "white",
    text: "Empowering data scientists and \nAI developers with automated \nresponsible AI pipelines",
    listItemCustomStyle: { width: "400px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const DATA_BENEFITS = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: "Infosys ai3s - shield",
  titleNumber: "2.",
  text: "Shield suite of offerings spans a range of technical and specialized \nsolutions, guardrails, and accelerators for protecting AI models from \nvulnerabilities. It helps embed 'Responsible by Design' principles\n across the AI lifecycle.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage(304),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(302),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "RESPONSIBLE_AI/AI3S_d1_03.png",
};

export default DATA_BENEFITS;
